import { Injectable, Inject } from '@angular/core';
import { LOCALE_ID } from '@angular/core';

@Injectable()
export class LocaleService {
    calendarDa = {
        firstDayOfWeek: 1,
            dayNames: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
            dayNamesShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
            dayNamesMin: ["Sø","Ma","Ti","On","To","Fr","Lø"],
            monthNames: [ "Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December" ],
            monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "Maj", "Jun","Jul", "Aug", "Sep", "Okt", "Nov", "Dec" ],
            today: 'Idag',
    }
constructor(
    @Inject(LOCALE_ID) public locale: string
) { }


    getCalendarDA(){
        return this.calendarDa;
    }
    getLocale(){
        return this.locale;
    }
    getTimeZone(){
        return new Date().getTimezoneOffset() / 60;
    }
}
